import { isUndefined } from 'lodash';

import {
  CONSUMER_GRADIENTS,
  ENTERPRISE_GRADIENTS,
  UNSUBSCRIBED_PREFERENCE,
} from 'bundles/marketing-consent/constants/GdprConstants';
import type { NotificationPreferencesV2Type } from 'bundles/naptimejs/resources/notificationPreferences.v2';

export const showBanner = (
  notificationPreferences?: NotificationPreferencesV2Type,
  isEnterprise = false,
  isAdmin = false
): boolean => {
  const shouldRenderConsumerBanner =
    !!notificationPreferences &&
    notificationPreferences.volunteer?.email === UNSUBSCRIBED_PREFERENCE &&
    notificationPreferences.promotions?.email === UNSUBSCRIBED_PREFERENCE &&
    notificationPreferences.recommendations?.email === UNSUBSCRIBED_PREFERENCE;
  const shouldRenderEnterpriseBanner =
    (!!notificationPreferences && isUndefined(notificationPreferences.enterpriseMarketing)) ||
    (!!notificationPreferences &&
      !!notificationPreferences.enterpriseMarketing &&
      notificationPreferences.enterpriseMarketing.email === UNSUBSCRIBED_PREFERENCE);

  /**
   * Scenarios when the GDPR Banner should be shown
   * 1. Enterprise + Admin gets notifications to keep their members on track
   * 2. Consumers get notifications to keep themselves on track
   *
   * Scenarios when the GDPR Banner should not be shown
   * 1. Enterprise consumers don't because we defer that to the administrators
   */
  if (isAdmin && isEnterprise) {
    return shouldRenderEnterpriseBanner;
  }
  if (!isAdmin && !isEnterprise) {
    return shouldRenderConsumerBanner;
  }
  return false;
};

export const getGradient = (isEnterprise = false, isAdmin = false) => {
  const gradientSrc = isEnterprise && isAdmin ? ENTERPRISE_GRADIENTS : CONSUMER_GRADIENTS;

  return gradientSrc[Math.floor(Math.random() * gradientSrc.length)];
};
